export default __webpack_public_path__ + "static/media/immaculateheartofmary.ff505ae1.jpg";